(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const root = document.documentElement;
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-ecom-campaign]').forEach((campaign) => {
      const messages = [...campaign.querySelectorAll('[data-ecom-campaign-message]')];
      const control = campaign.querySelector('[data-ecom-campaign-control]');
      let index = Math.max(0, messages.findIndex((message) => message.classList.contains('is-active')));
      let timer;
      let paused = false;

      const render = () => {
        messages.forEach((message, messageIndex) => {
          const active = messageIndex === index;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      const stop = () => window.clearTimeout(timer);
      const schedule = () => {
        stop();
        if (paused || motionQuery.matches || messages.length < 2 || document.hidden) return;
        timer = window.setTimeout(() => {
          index = (index + 1) % messages.length;
          render();
          schedule();
        }, 5200);
      };

      control?.addEventListener('click', () => {
        paused = !paused;
        campaign.classList.toggle('is-paused', paused);
        control.setAttribute('aria-label', paused ? 'Relancer les annonces' : 'Mettre les annonces en pause');
        if (paused) stop();
        else schedule();
      });

      campaign.addEventListener('mouseenter', stop);
      campaign.addEventListener('mouseleave', schedule);
      campaign.addEventListener('focusin', stop);
      campaign.addEventListener('focusout', schedule);
      document.addEventListener('visibilitychange', schedule);
      render();
      schedule();
    });

    const closeMegaMenus = (except = null) => {
      document.querySelectorAll('.hydros-header__mega[open]').forEach((details) => {
        if (details !== except) details.removeAttribute('open');
      });
    };

    document.querySelectorAll('.hydros-header__mega').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) closeMegaMenus(details);
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.hydros-header__mega')) closeMegaMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMegaMenus();
    });

    const whatsapp = document.querySelector('[data-ecom-whatsapp]');
    if (!whatsapp) return;

    const stickySelectors = [
      '[data-hynox-sticky]',
      '[data-lumos-sticky]',
      '.hynox-sticky',
      '.lumos-sticky',
    ];

    const updateWhatsappOffset = () => {
      const fallback = 'calc(18px + env(safe-area-inset-bottom))';
      const visibleSticky = stickySelectors
        .flatMap((selector) => [...document.querySelectorAll(selector)])
        .filter((element) => {
          const style = window.getComputedStyle(element);
          const rect = element.getBoundingClientRect();
          return (
            style.position === 'fixed' &&
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            Number.parseFloat(style.opacity || '1') > 0.05 &&
            rect.width > 0 &&
            rect.height > 0 &&
            rect.bottom > window.innerHeight - 4
          );
        })
        .sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)[0];

      if (!visibleSticky) {
        root.style.setProperty('--ecom-whatsapp-bottom', fallback);
        return;
      }

      const rect = visibleSticky.getBoundingClientRect();
      const offset = Math.ceil(window.innerHeight - rect.top + 14);
      root.style.setProperty('--ecom-whatsapp-bottom', `calc(${offset}px + env(safe-area-inset-bottom))`);
    };

    let ticking = false;
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        updateWhatsappOffset();
      });
    };

    updateWhatsappOffset();
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.addEventListener('scroll', requestUpdate, { passive: true });

    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver(requestUpdate);
      stickySelectors.flatMap((selector) => [...document.querySelectorAll(selector)]).forEach((element) => {
        observer.observe(element, { attributes: true, attributeFilter: ['class', 'style'] });
      });
    }
  });
})();
